<template>
  <!-- Hello Result --- {{ resultsText }} -->
  <div class="calculator">
    <div class="header">
      <h1>Withdraw Page</h1>
      <router-link to="/">Back</router-link>
      <!-- class="back-link" -->
    </div>
    <form @submit.prevent="calculateWithdraw">
      <div class="input-group">
        <div class="form-group">
          <label for="startYear01">Start Year 1:</label>
          <input
            type="number"
            v-model="startYear01"
            id="startYear01"
            required
          />
        </div>
        <div class="form-group">
          <label for="endYear01">End Year 1:</label>
          <input type="number" v-model="endYear01" id="endYear01" required />
        </div>
        <div class="form-group">
          <label for="withdrawAmount01">Withdraw 1:</label>
          <input
            type="number"
            v-model="withdrawAmount01"
            id="withdrawAmount01"
            required
          />
        </div>
      </div>
      <div class="input-group">
        <div class="form-group">
          <label for="startYear02" :class="{ 'gray-label': !startYear02 }"
            >Start Year 2:</label
          >
          <input type="number" v-model="startYear02" id="startYear02" />
        </div>
        <div class="form-group">
          <label for="endYear02" :class="{ 'gray-label': !endYear02 }"
            >End Year 2:</label
          >
          <input type="number" v-model="endYear02" id="endYear02" />
        </div>
        <div class="form-group">
          <label
            for="withdrawAmount02"
            :class="{ 'gray-label': !withdrawAmount02 }"
            >Withdraw 2:</label
          >
          <input
            type="number"
            v-model="withdrawAmount02"
            id="withdrawAmount02"
          />
        </div>
      </div>
      <div class="form-group">
        <label for="targetAge_wd">Target Age:</label>
        <input
          type="number"
          v-model="targetAge_wd"
          id="targetAge_wd"
          required
        />
      </div>
      <div class="form-group">
        <label for="targetValue_wd">Target Value:</label>
        <input
          type="number"
          v-model="targetReturnValue_wd"
          id="targetValue_wd"
          required
        />
      </div>
      <button type="submit" class="calculate-button">Calculate Rate</button>
    </form>

    <!-- New text area for results -->
    <textarea
      v-model="resultsText_sc_wd"
      class="results-area-sc-wd"
      readonly
    ></textarea>

    <!-- New text area for results -->
    <textarea
      v-model="resultsText_tc_wd"
      class="results-area-tc-wd"
      readonly
    ></textarea>

    <div class="button-container">
      <button @click="clearResults" class="action-button clear-button">
        Clear
      </button>
      <button @click="copyToClipboard('sc')" class="action-button copy-button">
        Copy SC
      </button>
      <button @click="copyToClipboard('tc')" class="action-button copy-button">
        Copy TC
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        // startYear01: null,
        // endYear01: null,
        // withdrawAmount01: null,
        // startYear02: null,
        // endYear02: null,
        // withdrawAmount02: null,
        // targetAge_wd: 75,
        // targetValue_wd: 767072,
        resultsText: '',
        // currentAge: 50, // Assuming starting age is 50
        // annualPayment: 50000,
        // paymentYears: 10,
      }
    },

    computed: {
      startYear01: {
        get() {
          return this.$store.state.startYear01
        },
        set(value) {
          this.$store.commit('setStartYear01', value)
        },
      },

      startYear02: {
        get() {
          return this.$store.state.startYear02
        },
        set(value) {
          this.$store.commit('setStartYear02', value)
        },
      },

      endYear01: {
        get() {
          return this.$store.state.endYear01
        },
        set(value) {
          this.$store.commit('setEndYear01', value)
        },
      },

      endYear02: {
        get() {
          return this.$store.state.endYear02
        },
        set(value) {
          this.$store.commit('setEndYear02', value)
        },
      },

      withdrawAmount01: {
        get() {
          return this.$store.state.withdrawAmount01
        },
        set(value) {
          this.$store.commit('setWithdrawAmount01', value)
        },
      },

      withdrawAmount02: {
        get() {
          return this.$store.state.withdrawAmount02
        },
        set(value) {
          this.$store.commit('setWithdrawAmount02', value)
        },
      },

      selectedCurrency: {
        get() {
          return this.$store.state.selectedCurrency
        },
        set(value) {
          this.$store.commit('setSelectedCurrency', value)
        },
      },
      resultsText_sc: {
        get() {
          return this.$store.state.resultsText_sc
        },
        set(value) {
          this.$store.commit('setResultsText_sc', value)
        },
      },
      resultsText_tc: {
        get() {
          return this.$store.state.resultsText_tc
        },
        set(value) {
          this.$store.commit('setResultsText_tc', value)
        },
      },

      resultsText_sc_wd: {
        get() {
          return this.$store.state.resultsText_sc_wd
        },
        set(value) {
          this.$store.commit('setResultsText_sc_wd', value)
        },
      },
      resultsText_tc_wd: {
        get() {
          return this.$store.state.resultsText_tc_wd
        },
        set(value) {
          this.$store.commit('setResultsText_tc_wd', value)
        },
      },

      currentAge: {
        get() {
          return this.$store.state.currentAge
        },
        set(value) {
          this.$store.commit('setCurrentAge', value)
        },
      },
      annualPayment: {
        get() {
          return this.$store.state.annualPayment
        },
        set(value) {
          this.$store.commit('setAnnualPayment', value)
        },
      },
      paymentYears: {
        get() {
          return this.$store.state.paymentYears
        },
        set(value) {
          this.$store.commit('setPaymentYears', value)
        },
      },
      targetAge: {
        get() {
          return this.$store.state.targetAge
        },
        set(value) {
          this.$store.commit('setTargetAge', value)
        },
      },
      targetReturnValue: {
        get() {
          return this.$store.state.targetReturnValue
        },
        set(value) {
          this.$store.commit('setTargetReturnValue', value)
        },
      },
      targetAge_wd: {
        get() {
          return this.$store.state.targetAge_wd
        },
        set(value) {
          this.$store.commit('setTargetAge_wd', value)
        },
      },
      targetReturnValue_wd: {
        get() {
          return this.$store.state.targetReturnValue_wd
        },
        set(value) {
          this.$store.commit('setTargetReturnValue_wd', value)
        },
      },
    },

    methods: {
      calculateWithdraw() {
        // const irr = this.findIRR(
        //   this.currentAge,
        //   this.annualPayment,
        //   this.paymentYears,
        //   this.startYear01,
        //   this.endYear01,
        //   this.withdrawAmount01,
        //   this.startYear02,
        //   this.endYear02,
        //   this.withdrawAmount02,
        //   this.targetAge_wd,
        //   this.targetValue_wd
        // )

        const duration = this.targetAge_wd - this.currentAge
        let targetValue_wd = this.targetReturnValue_wd
        let annualPayment = this.annualPayment
        let paymentYears = this.paymentYears
        let tolerance = 1
        let maxIterations = 1000

        let startYear1 = this.startYear01
        let endYear1 = this.endYear01
        let withdraw1 = this.withdrawAmount01

        let startYear2 = this.startYear02
        let endYear2 = this.endYear02
        let withdraw2 = this.withdrawAmount02

        let currentAge = this.currentAge
        let targetAge_wd = this.targetAge_wd

        // const irr = this.findDiscountRate(
        //   targetValue_wd,
        //   annualPayment,
        //   paymentYears,
        //   duration,
        //   tolerance,
        //   maxIterations
        // )

        const result_wd = this.findDiscountRate(
          targetValue_wd,
          annualPayment,
          paymentYears,
          currentAge,
          targetAge_wd,
          startYear1,
          endYear1,
          withdraw1,
          startYear2,
          endYear2,
          withdraw2,
          (tolerance = 1),
          (maxIterations = 1000)
        )

        // 2025-06-24 ~~~~~~~~~~~~~

        let yearsOfWithdrawal = Math.min((this.targetAge_wd - (this.currentAge + this.startYear01) + 1), (this.endYear01 - this.startYear01 + 1));
        yearsOfWithdrawal = Math.max(yearsOfWithdrawal, 0); // Ensure it's not negative

        // Calculate total withdrawal amount
        let totalWithdrawal = yearsOfWithdrawal * this.withdrawAmount01;

        // 2025-06-24 ~~~~~~~~~~~~~

        this.$store.commit('setResult_wd', result_wd)

        console.log("all Parameters--->",
          targetValue_wd,
          annualPayment,
          paymentYears,
          duration,
          tolerance,
          maxIterations
        )
        console.log("2025-06-24---->",
          yearsOfWithdrawal, totalWithdrawal
        )

        // this.resultsText = `IRR: ${(irr * 100).toFixed(4)}%`
        console.log('irr 20250624---->', result_wd)
        // console.log('irr rate ---->', irr.discountRate)

        const currencySymbol =
          this.selectedCurrency === 'Other' ? '' : this.selectedCurrency + ' '

        const newResult_sc_wd = `${
          this.targetAge_wd
        } 岁时，提取了 ${yearsOfWithdrawal} 年，共提取 ${currencySymbol}${(totalWithdrawal/ 10000
        ).toFixed(2)} 万元; 保单价值增加到 ${currencySymbol}${(
          this.targetReturnValue_wd / 10000
        ).toFixed(2)} 万元，复利 IRR ${(result_wd.discountRate * 100).toFixed(
          4
        )}%\n\n`

        const newResult_tc_wd = `${
          this.targetAge_wd
        } 歲時，提取了 ${yearsOfWithdrawal} 年，共提取 ${currencySymbol}${(totalWithdrawal/ 10000
        ).toFixed(2)} 萬元; 保單價值增加到 ${currencySymbol}${(
          this.targetReturnValue_wd / 10000
        ).toFixed(2)} 萬元，複利 IRR ${(result_wd.discountRate * 100).toFixed(
          4
        )}%\n\n`

        // this.resultsText_sc += newResult_sc
        // this.resultsText_tc += newResult_tc

        this.resultsText_sc_wd += newResult_sc_wd
        this.resultsText_tc_wd += newResult_tc_wd
      },

      // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

      clearResults() {
        this.resultsText_sc_wd = ''
        this.resultsText_tc_wd = ''
      },

      copyToClipboard(args) {
        if (args === 'sc') {
          navigator.clipboard
            .writeText(this.resultsText_sc_wd)
            .then(() => {
              alert('SC Results copied to clipboard!')
            })
            .catch((err) => {
              console.error('Failed to copy text: ', err)
              alert('Failed to copy to clipboard. Please try again.')
            })
        } else if (args === 'tc') {
          navigator.clipboard
            .writeText(this.resultsText_tc_wd)
            .then(() => {
              alert('TC Results copied to clipboard!')
            })
            .catch((err) => {
              console.error('Failed to copy text: ', err)
              alert('Failed to copy to clipboard. Please try again.')
            })
        }
      },

      // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

      presentValueSinglePayment(payment, rate, year) {
        return payment / (1 + rate) ** year
      },

      calculateTotalPresentValue(annualPayment, paymentYears, rate) {
        const presentValues = []
        for (let year = 0; year < paymentYears; year++) {
          presentValues.push(
            this.presentValueSinglePayment(annualPayment, rate, year)
          )
        }
        return presentValues.reduce((acc, val) => acc + val, 0)
      },

      findDiscountRate(
        targetValue_wd,
        annualPayment,
        paymentYears,
        currentAge,
        targetAge_wd,
        startYear1,
        endYear1,
        withdraw1,
        startYear2,
        endYear2,
        withdraw2,
        tolerance = 1,
        maxIterations = 1000
      ) {
        let lowRate = 0.0
        let highRate = 1.0
        let iterations = 0
        while (iterations < maxIterations) {
          const midRate = (lowRate + highRate) / 2

          // Calculate present value of initial payments
          const totalPresentValue = this.calculateTotalPresentValue(
            annualPayment,
            paymentYears,
            midRate
          )

          // Calculate present value of withdrawals 1
          let withdrawalsPresentValue1 = 0
          const actualEndYear1 = Math.min(endYear1, targetAge_wd - currentAge)

          console.log('targetAge_wd - currentAge)', targetAge_wd, currentAge)
          console.log('withdraw 1--->', withdrawalsPresentValue1)
          console.log('startYear 1--->', startYear1, endYear1, withdraw1)
          console.log('actualEndYear1 --->', actualEndYear1)

          for (let year = startYear1; year <= actualEndYear1; year++) {
            withdrawalsPresentValue1 += this.presentValueSinglePayment(
              withdraw1,
              midRate,
              year
            )
          }

          // Calculate present value of withdrawals 2 (if applicable)
          let withdrawalsPresentValue2 = 0
          if (startYear2 !== null && endYear2 !== null && withdraw2 !== null) {
            const actualEndYear2 = Math.min(endYear2, targetAge_wd - currentAge)
            for (let year = startYear2; year <= actualEndYear2; year++) {
              withdrawalsPresentValue2 += this.presentValueSinglePayment(
                withdraw2,
                midRate,
                year
              )
            }
          }

          // Calculate present value of final return
          const duration = targetAge_wd - currentAge
          const presentValueOfReturn = this.presentValueSinglePayment(
            targetValue_wd,
            midRate,
            duration
          )

          // Calculate the total difference
          const difference =
            presentValueOfReturn +
            withdrawalsPresentValue1 +
            withdrawalsPresentValue2 -
            totalPresentValue

          if (Math.abs(difference) < tolerance) {
            return {
              discountRate: midRate,
              totalPresentValue,
              withdrawalsPresentValue1,
              withdrawalsPresentValue2,
              presentValueOfReturn,
            }
          }
          if (difference > 0) {
            lowRate = midRate
          } else {
            highRate = midRate
          }
          iterations++
        }
        return null
      }

      // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    },
  }
</script>

<style scoped>
  .results-area-sc-wd {
    width: 90%;
    height: 100px;
    margin: 20px 5px;
    padding: 10px;
    font-size: 14px;
    border: 1px solid #ccc;
    border-radius: 5px;
    resize: vertical;
  }

  .results-area-tc-wd {
    width: 90%;
    height: 100px;
    /* margin: 20px 5px; */
    padding: 10px;
    font-size: 14px;
    border: 1px solid #ccc;
    border-radius: 5px;
    resize: vertical;
  }

  .button-container {
    display: flex;
    justify-content: space-between;
    /* justify-content: center;  */
    margin-left: 15px;
    margin-right: 15px;
    padding: 10px;
  }

  .action-button {
    width: 32%;
    padding: 10px;
    font-size: 16px;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }

  .clear-button {
    background-color: #dc3545;
  }

  .clear-button:hover {
    background-color: #c82333;
  }

  .copy-button {
    background-color: #28a745;
  }

  .copy-button:hover {
    background-color: #218838;
  }

  .calculator {
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
    padding: 20px;
    box-sizing: border-box;
    background-color: #000;
    color: white;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }

  h1 {
    font-size: 24px;
    margin: 0;
  }

  .back-link {
    color: #a855f7;
    text-decoration: none;
    font-size: 16px;
  }

  .input-group {
    border: 1px solid #444;
    border-radius: 5px;
    padding: 15px;
    margin-bottom: 15px;
    width: 100%;
    box-sizing: border-box;
  }

  .form-group {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .form-group label {
    flex: 0 0 100px;
    margin-right: 10px;
    text-align: right;
    font-size: 16px;
  }

  .form-group input {
    flex: 1;
    padding: 10px;
    font-size: 16px;
    border: 1px solid #444;
    border-radius: 5px;
    background-color: #333;
    color: white;
    width: calc(100% - 110px); /* Adjust based on label width */
    box-sizing: border-box;
  }

  .gray-label {
    color: #888;
  }

  .calculate-button {
    width: 100%;
    margin-top: 15px;
    padding: 10px;
    font-size: 16px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }

  .calculate-button:hover {
    background-color: #0056b3;
  }
</style>
